import React, {
  useCallback, useEffect, useMemo, useState,
} from 'react';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';

import CFV2Actions from '@Actions/configurations/cfV2Actions';
import ProductActions from '@Actions/productActions';
import { QUANTITY } from '@Apis/constants';
import Helpers from '@Apis/helpers';
import CategoryFilterNew from '@Components/Common/CategoryFilterNew';
import {
  faAdd, faCheck, faPlus, faSliders, faXmark,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import closeIcon from '@Images/icons/icon-close-blue.png';
import defaultImage from '@Images/icons/imageDefault.png';
import H3Image from '@Uilib/h3Image';
import H3Text from '@Uilib/h3Text';
import {
  Drawer, Image, Popover, Switch, Table, Tooltip,
} from 'antd';
import { v4 as uuidv4 } from 'uuid';
import AdvanceFilter from '../AdvanceFilter';
import SelectDepartment from '../SelectDepartment';
import PRZButton from '../UI/PRZButton';
import PRZSelect from '../UI/PRZSelect';
import './style.scss';

const AdvanceProductSearch = ({
  user, open, onClose, selectedTenant, tenantDepartmentId, excludeOutOfStock, productTypes, isSalesProduct, isPurchaseProduct, filterReservedQuantity, isShopifyProduct, onSelectedProduct, excludedProducts, getDocCFV2, customFieldsProps, getCFV2Loading, getDocCFV2Success, searchProducts, searchResults, searchProductsLoading, loading, advanceSearchResults, advanceSearchProductsLoading, disableMultiSelect, excludedProductsByProductSkuId,
}) => {
  const [searchKeyword, setSearchKeyword] = useState('');
  const [selectedStatus, setSelectedStatus] = useState('');
  const [selectedProductType, setSelectedProductType] = useState(productTypes || []);
  const [selectedCategory, setSelectedCategory] = useState([]);
  const [selectedDepartment, setSelectedDepartment] = useState(tenantDepartmentId);
  const [marketplaceProduct, setMarketplaceProduct] = useState(false);
  const [openAdvanceProductFiltersDrawer, setOpenAdvanceProductFiltersDrawer] = useState(false);
  const [advanceFilters, setAdvanceFilters] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [currentPageSize, setCurrentPageSize] = useState(25);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);

  const [call, setCall] = useState(false);

  useEffect(() => {
    const payload = {
      orgId: user?.tenant_info?.org_id,
      entityName: 'PRODUCTS',
    };
    getDocCFV2(payload);
  }, []);

  useEffect(() => {
    searchProducts({
      // keyword: searchKeyword,
      tenantId: selectedTenant,
      stockStatus: selectedStatus,
      page: currentPage,
      limit: currentPageSize,
      tenantDepartmentId: selectedDepartment,
      excludeOutOfStock,
      productType: selectedProductType?.join(','),
      category: selectedCategory?.join(','),
      isSalesProduct,
      isPurchaseProduct,
      search: true,
      filterReservedQuantity,
      barcode: null,
      isShopifyProduct,
      isMarketplaceProduct: marketplaceProduct,
      advanceFilters,
      isAdvanceProductSearch: true,
    });
    // setAdvanceFilters('');
    setSelectedRowKeys([]);
    setSelectedRows([]);
  }, [call]);

  const customFieldOptions = useMemo(() => {
    if (customFieldsProps) {
      const data = {
        customFields: [
          ...customFieldsProps?.data?.document_custom_fields,
          ...customFieldsProps?.data?.document_line_custom_fields,
        ],
      };
      const fieldOptions = data?.customFields?.filter((item) => item.is_active);
      return fieldOptions;
    }
    return [];
  }, [customFieldsProps]);

  const statusOptions = [
    {
      value: '',
      label: 'All Status',
      key: 'ALL_STATUS',
    },
    {
      value: 'WELL_STOCKED',
      label: 'Well Stocked',
      key: 'WELL_STOCKED',
    },
    {
      value: 'RUNNING_LOW',
      label: 'Running Low',
      key: 'RUNNING_LOW',
    },
    {
      value: 'OUT_OF_STOCK',
      label: 'Out of Stock',
      key: 'OUT_OF_STOCK',
    },
  ];

  // productTypeOptions will be mapped based on the product types coming from document where productFilterV2 is using.
  const productTypeOptions = productTypes?.map((type) => {
    const option = {
      value: type,
      label: type.replaceAll('_', ' ').toProperCase(),
      key: type,
    };

    return option;
  });

  const isDisabledProduct = useCallback((productData) => (excludedProductsByProductSkuId ? excludedProducts?.includes(JSON.stringify(productData?.product_sku_id)) : excludedProducts?.includes(JSON.stringify(productData?.tenant_product_id))), [excludedProducts]);

  const getProductColumns = () => {
    const inventoryConfig = user?.tenant_info?.inventory_config;
    const globalConfig = user?.tenant_info?.global_config;
    const departmentLevelStock = inventoryConfig?.settings?.department_level_stock;
    const showStockToOtherDepartment = inventoryConfig?.settings?.show_stock_to_other_department;
    const showItemDescription = globalConfig?.settings?.print_description_automatically;
    const DescriptionDisplay = ({ description }) => {
      const isLongDescription = description && description?.length > 50;

      return (
        <div>
          {isLongDescription ? (
            <Tooltip
              color="rgb(234, 242, 254)"
              title={(
                <div
                  style={{ color: 'black', fontSize: '13px' }}
                  className="table-subscript"
                  dangerouslySetInnerHTML={{ __html: description }}
                />
              )}
            >
              <div
                className="table-subscript"
                dangerouslySetInnerHTML={{
                  __html: `${description?.substring(0, 50)}...more`,
                }}
              />
            </Tooltip>
          ) : (
            <div
              className="table-subscript"
              dangerouslySetInnerHTML={{ __html: description }}
            />
          )}
        </div>
      );
    };
    const columns = [
      {
        title: '',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        width: '50px',
        className: 'prod-table__image-column',
        render: (record) => (
          <div style={{ width: '40px' }}>
            {record?.product_info?.assets?.length > 0 ? (
              <Image.PreviewGroup
                items={record?.product_info?.assets?.map((item) => ({
                  src: item?.url,
                }))}
              >
                {record?.product_info?.assets?.map((item, i) => (i === 0 ? (
                  <Image
                    width={40}
                    height={40}
                    src={item?.url}
                    className="product__image"
                    key={item?.url}
                  />
                ) : (
                  <Image
                    width={0}
                    height={0}
                    src={item?.url}
                    className="product__image product__image-none"
                    key={item?.url}
                  />
                )))}
              </Image.PreviewGroup>
            ) : (
              <img className="prod-table__image__default" src={defaultImage} alt="Product Thumbnail" />
            )}
          </div>
        ),
        fixed: 'left',
      },
      {
        title: 'SKU#',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        render: (text, record) => (
          <H3Text text={record?.product_info?.internal_sku_code} />
        ),
        fixed: 'left',
      },
      {
        title: 'PRODUCT NAME',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        render: (text, record) => (
          <div style={{ maxWidth: '500px' }}>
            <div className="prod-table__text">
              {record?.product_info?.product_sku_name}
            </div>
            {record.product_type !== 'STORABLE' && record.product_type && (
              <div
                className="inventory-qr__status"
                style={{
                  backgroundColor: Helpers.getProductType(record.product_type)
                    ?.color,
                }}
              >
                {Helpers.getProductType(record.product_type)?.text}
              </div>
            )}
            {showItemDescription && (
              <DescriptionDisplay
                description={record?.product_info?.description?.replace(
                  /<[^>]+>/g,
                  '',
                )}
              />
            )}
            {record?.product_category_info?.category_path && (
              <Tooltip
                overlay={(
                  <div
                    style={{
                      color: 'rgb(0, 0, 0)',
                      fontSize: '12px',
                      fontWeight: '500',
                      padding: '2px',
                    }}
                  >
                    {record.product_category_info.category_path.join(' / ')}
                  </div>
                )}
                color="rgb(234, 242, 254)"
              >
                {' '}
                {/* Tooltip wrapping the div */}
                <div
                  className="inventory-qr__status"
                  style={{ backgroundColor: '#3aa5a6' }}
                >
                  {/* Displaying only the last category name with ellipsis if path is long */}
                  {record?.product_category_info
                    ? `.../${record?.product_category_info?.product_category_name}`
                    : ''}
                </div>
              </Tooltip>
            )}
            {user?.tenant_info?.global_config?.settings?.marketplace_enabled
              && record.is_marketplace_product && (
                <div
                  className="inventory-qr__status"
                  style={{ backgroundColor: '#f58428' }}
                >
                  Marketplace
                </div>
              )}
          </div>
        ),
      },
      {
        title: (
          <React.Fragment>
            <span style={{ fontSize: '12px' }}>AVAILABLE STOCK</span>
          </React.Fragment>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        render: (record) => {
          const uomInfo = record?.uom_info;
          const uomList = record?.uom_list;
          const value = record?.department_quantity || 0;
          const quantityInDiffUoms = (
            <div>
              {uomList?.map((uom, i) => (
                <div className="other-uom-stock" key={i}>
                  <div>
                    {QUANTITY(
                      (value * uomInfo?.ratio) / uom?.ratio,
                      uom?.precision,
                    )}
                  </div>
                  <div>{uom?.uqc?.toProperCase()}</div>
                </div>
              ))}
            </div>
          );
          return (
            <React.Fragment>
              {['STORABLE', 'BUNDLE'].includes(
                record?.product_type?.toUpperCase(),
              )
                ? (
                  <React.Fragment>
                    <Popover
                      placement="bottom"
                      content={quantityInDiffUoms}
                      title="Quantity in other units"
                      trigger="hover"
                    >
                      <div style={{ cursor: 'pointer' }}>
                        {`${QUANTITY(
                          value || '0',
                          record?.uom_info?.precision,
                        )} ${record?.uom_info?.uqc?.toProperCase()}`}
                      </div>
                    </Popover>
                  </React.Fragment>
                )
                : (
                  '-'
                )}
            </React.Fragment>
          );
        },
      },
      {
        title: '',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        render: (text, record) => (
          <PRZButton
            type="primary"
            buttonStyle={{
              width: 'fit-content', borderRadius: '5px',
            }}
            onClick={() => {
              onSelectedProduct([record], () => {
                setSelectedRowKeys([]);
                setSelectedRows([]);
              });
            }}
            disabled={isDisabledProduct(record)}
          >
            Add
            &nbsp;
            <FontAwesomeIcon icon={faAdd} />
          </PRZButton>
        ),
        fixed: 'right',
      },
    ];

    return columns;
  };

  const getProductsWithKey = useMemo(() => {
    const productsCopy = advanceSearchResults?.result?.products ? JSON.parse(JSON.stringify(advanceSearchResults?.result?.products)) : [];
    for (let i = 0; i < productsCopy?.length; i++) {
      productsCopy[i].key = uuidv4();
    }
    return productsCopy;
  }, [advanceSearchResults]);

  const applyProductFilter = () => {
    setCurrentPage(1);
    setCall(!call);
  };

  const clearProductFilter = () => {
    setSelectedStatus('');
    setSelectedProductType(productTypes || []);
    setSelectedCategory([]);
    setMarketplaceProduct(false);
    setAdvanceFilters('');
    setCurrentPage(1);
    setCall(!call);
  };

  return (
    <React.Fragment>
      <div className="advance_product_search_wrapper">
        <div className="ant-row">
          <div className="ant-col-8">
            <div className="advance_product_search-row">
              <div className="advance_product_search-row__label">Stock Status</div>
              <div className="advance_product_search-row__input">
                <PRZSelect
                  value={selectedStatus}
                  options={statusOptions}
                  placeholder="Select Status..."
                  size="middle"
                  onChange={(value) => {
                    setSelectedStatus(value);
                  }}
                  disabled={loading}
                />
              </div>
            </div>
          </div>

          <div className="ant-col-8">
            <div className="advance_product_search-row">
              <div className="advance_product_search-row__label">Product Type</div>
              <div className="advance_product_search-row__input">
                <PRZSelect
                  value={selectedProductType}
                  options={productTypeOptions}
                  placeholder="Product Type"
                  mode="multiple"
                  maxTagCount="responsive"
                  size="middle"
                  onChange={(value) => {
                    if (value.length > 0) {
                      setSelectedProductType(value);
                    }
                  }}
                  disabled={loading}
                />
              </div>
            </div>
          </div>

          <div className="ant-col-8">
            <div className="advance_product_search-row">
              <div className="advance_product_search-row__label">Product Category</div>
              <div className="advance_product_search-row__input">
                <CategoryFilterNew
                  selectedCategory={selectedCategory}
                  containerClassName="section-status"
                  hideTitle
                  placeholder="Product Category"
                  style={{
                    width: '100%',
                    height: '35px',
                    border: 'none',
                    borderRadius: '5px',
                  }}
                  onChange={(value) => {
                    setSelectedCategory(value);
                  }}
                  allowClear
                  disabled={loading}
                />
              </div>
            </div>
          </div>

          <div className="ant-col-8">
            <div className="advance_product_search-row">
              <div className="advance_product_search-row__label">Select Department</div>
              <div className="advance_product_search-row__input">
                <SelectDepartment
                  hideTitle
                  selectedDepartment={Number(selectedDepartment) || ''}
                  noDropdownAlign
                  onChange={(value) => {
                    setSelectedDepartment(value?.tenant_department_id);
                  }}
                  customStyle={{
                    borderRadius: '4px',
                    width: '100%',
                    fontSize: '13px',
                  }}
                  tenentLevelDepartment
                  tenantId={user.tenant_info?.tenant_id}
                  disabled={tenantDepartmentId}
                />
              </div>
            </div>
          </div>

          <div className="ant-col-8">
            <div className="advance_product_search-row">
              <div className="advance_product_search-row__label">Marketplace Products</div>
              <div className="advance_product_search-row__switch">
                <Switch
                  checked={marketplaceProduct}
                  onChange={() => setMarketplaceProduct(!marketplaceProduct)}
                  disabled={loading}
                />
              </div>
            </div>
          </div>
        </div>

        <div className="ant-row advanced-filter__container" onClick={() => setOpenAdvanceProductFiltersDrawer(true)}>
          <H3Text
            text={(
              <div style={{ display: 'flex', alignItems: 'center' }}>
                Advanced Filter
                &nbsp;
                <FontAwesomeIcon icon={faSliders} />
                {/* &nbsp;
                <span className="new__tag">New</span> */}
              </div>
            )}
            className="action-button-text"
          />
        </div>

        <div className="ant-row">
          <div className="advance_product_search-row__filter">
            <PRZButton
              type="primary"
              onClick={() => applyProductFilter()}
              disabled={loading}
              className="advance_product_search-row__filter__apply_filter"
            >
              Apply Filter
              &nbsp;
              <FontAwesomeIcon icon={faCheck} />
            </PRZButton>

            <PRZButton
              type="default"
              onClick={() => clearProductFilter()}
              disabled={loading}
              className="advance_product_search-row__filter__clear_filter"
            >
              Clear Filter
              &nbsp;
              <FontAwesomeIcon icon={faXmark} />
            </PRZButton>
          </div>
        </div>

        <div
          className="table-container"
        >
          <Table
            title={() => (
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <H3Text
                  text={`${advanceSearchResults && advanceSearchResults.count ? advanceSearchResults.count : '0'
                    } Products In Your Inventory`}
                  className=""
                />
                <div className="filters__buttons">
                  {selectedRowKeys?.length > 0 && (
                    <div
                      className="action-buttons"
                    >
                      <PRZButton
                        type="primary"
                        buttonStyle={{
                        }}
                        onClick={() => {
                          onSelectedProduct(selectedRows, () => {
                            setSelectedRowKeys([]);
                            setSelectedRows([]);
                          });
                        }}
                      >
                        Add Selected
                        &nbsp;
                        <FontAwesomeIcon icon={faPlus} style={{ color: '#fffff !Important' }} />
                      </PRZButton>
                    </div>
                  )}
                </div>
              </div>
            )}
            loading={advanceSearchProductsLoading || getCFV2Loading || loading}
            showHeader
            size="small"
            scroll={{ x: 'max-content' }}
            columns={getProductColumns()}
            bordered
            dataSource={
              advanceSearchResults && advanceSearchResults?.result?.products
                ? getProductsWithKey
                : []
            }
            pagination={
              advanceSearchResults?.count > currentPageSize
                ? {
                  current: currentPage,
                  total: advanceSearchResults ? advanceSearchResults.count : 0,
                  pageSize: currentPageSize,
                  position: ['bottomLeft'],
                  showSizeChanger: true,
                  showTotal: (tot, range) => `${range[0]}-${range[1]} of ${tot} items`,
                  onChange: (page, pageSize) => {
                    setCurrentPage(page);
                    setCurrentPageSize(pageSize);
                    setCall(!call);
                  },
                  pageSizeOptions: ['25', '50'],
                }
                : false
            }
            rowSelection={
              !disableMultiSelect && window.screen.width > 325
                ? {
                  selectedRowKeys,
                  onChange: (rowKeys, rows) => {
                    setSelectedRowKeys(rowKeys);
                    setSelectedRows(rows);
                  },
                  getCheckboxProps: (record) => ({
                    disabled: isDisabledProduct(record),
                  }),
                }
                : false
            }
            rowClassName={(record) => (isDisabledProduct(record) ? 'disabled-row' : '')}
          />
        </div>

      </div>

      <Drawer
        open={openAdvanceProductFiltersDrawer}
        width="820px"
        mask
        onClose={() => setOpenAdvanceProductFiltersDrawer(false)}
        destroyOnClose
      >
        <div className="custom-drawer__header-wrapper">
          <div className="custom-drawer__header" style={{ width: '770px' }}>
            <H3Text text="Apply Advance Filters" className="custom-drawer__title" />
            <H3Image src={closeIcon} className="custom-drawer__close-icon" onClick={() => setOpenAdvanceProductFiltersDrawer(false)} />
          </div>
        </div>
        <AdvanceFilter
          customFieldOptions={customFieldOptions}
          advanceFilters={advanceFilters}
          setAdvanceFilters={setAdvanceFilters}
          setOpenAdvanceProductFiltersDrawer={setOpenAdvanceProductFiltersDrawer}
          setOpenProductFiltersDrawer={() => { }}
          customKey="prz-advance-filter-product"
        />
      </Drawer>
    </React.Fragment>
  );
};

const mapStateToProps = ({ UserReducers, CFV2Reducers, ProductReducers }) => ({
  user: UserReducers.user,
  customFieldsProps: CFV2Reducers.cfV2DocProducts,
  getCFV2Loading: CFV2Reducers.getCFV2Loading,
  searchResults: ProductReducers.searchResults,
  searchProductsLoading: ProductReducers.searchProductsLoading,
  advanceSearchResults: ProductReducers.advanceSearchResults,
  advanceSearchProductsLoading: ProductReducers.advanceSearchProductsLoading,
});

const mapDispatchToProps = (dispatch) => ({
  getDocCFV2: (payload, callback) => dispatch(CFV2Actions.getDocCFV2(payload, callback)),
  getDocCFV2Success: (customFieldsDocV2) => dispatch(CFV2Actions.getDocCFV2Success(customFieldsDocV2)),
  searchProducts: (params, callback) => dispatch(ProductActions.searchProducts(params, callback)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(AdvanceProductSearch));
